module.exports = __webpack_public_path__ + "img/hard-soft-consonants.ff3a5c31.jpg";